import * as React from 'react';
import classnames from 'classnames';

import './table.scss';

type Props = {
  children: React.ReactNode,
  style: 'flat' | 'volume' | 'none',
  className?: string
};

class Table extends React.PureComponent<Props> {
  static defaultProps = {
    style: 'volume'
  };

  render(): React.ReactNode {
    const { children, className, style } = this.props;

    const tableClasses = classnames('table', className, {
      [`table--style-${style}`]: style
    });

    return (
      <section className={tableClasses}>
        {children}
      </section>
    );
  }
}

export default Table;
